export enum InsumoEstado {
  Borrador,
  VerificadoYActualizado,
  VerificadoYDesactualizado,
  Discontinuado,
  NoVerificado,
}

export const InsumoEstadoLabels: { [key in InsumoEstado]: string } = {
  [InsumoEstado.Borrador]: 'Borrador',
  [InsumoEstado.VerificadoYActualizado]: 'Verificado',
  [InsumoEstado.VerificadoYDesactualizado]: 'Verificado',
  [InsumoEstado.NoVerificado]: 'NoVerificado',
  [InsumoEstado.Discontinuado]: 'Discontinuado',
};

export const getInsumoEstado = () => {
  return Object.values(InsumoEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: InsumoEstadoLabels[id as InsumoEstado],
    }));
};

export const colorMapping: { [key in InsumoEstado]: string } = {
  [InsumoEstado.Borrador]: '#70BDFF',
  [InsumoEstado.VerificadoYActualizado]: '#22c55e',
  [InsumoEstado.VerificadoYDesactualizado]: 'orange',
  [InsumoEstado.NoVerificado]: '#007bff',
  [InsumoEstado.Discontinuado]: 'black',
};

/*----------------------------------------------------------------------------------------*/

export enum StockInfoEstado {
  SinStock,
  StockInsuficiente,
  ConStock,
}

export const StockInfoEstadoLabels: { [key in StockInfoEstado]: string } = {
  [StockInfoEstado.SinStock]: 'Sin stock',
  [StockInfoEstado.StockInsuficiente]: 'Stock insuficiente',
  [StockInfoEstado.ConStock]: 'En stock',
};

export const colorMappingStock: { [key in StockInfoEstado]: string } = {
  [StockInfoEstado.SinStock]: 'red',
  [StockInfoEstado.StockInsuficiente]: 'orange',
  [StockInfoEstado.ConStock]: 'green',
};

export interface LoteInfo {
  codigoInsumo: string;
  descripcionInsumo?: string;
  proveedorRazonSocial: string;
  codigoProveedor: string;
  vencimiento: string;
  lote: string;
  cantidadEnStock: number;
  cantidadNecesaria: number;
  unidadDeConsumoId: string;
}
export interface StockInfo {
  codigoProducto: string;
  codigoInsumo: string;
  descripcionInsumo?: string;
  estado: StockInfoEstado;
  stock: number;
  cantidadAProducir: number;
  insumosAConsumir: Array<LoteInfo>;
  unidadDeConsumoId: string;
}
